import { Link } from "react-router-dom";
import { Mail } from "lucide-react";
import { useStore } from "@/context/StoreContext";
import { useLang } from "@/context/LangContext";

export default function ContactButton({ subject = "", className = "", compact = false, testId = "contact-button" }) {
  const { settings } = useStore();
  const { t } = useLang();
  const email = settings.contact_email;
  const label = compact ? "" : t("contact.buttonLabel");
  const cls = `${className} flex items-center gap-2 border border-brass/60 bg-brass/10 font-mono text-[10px] tracking-[0.25em] text-brass transition-colors duration-300 hover:bg-brass hover:text-ink ${compact ? "px-3 py-2" : "px-5 py-3"}`;
  const sub = subject ? `?subject=${encodeURIComponent(subject)}` : "";
  if (email) {
    return (
      <a data-testid={testId} href={`mailto:${email}${sub}`} className={cls} aria-label={t("contact.buttonLabel")} title={email}>
        <Mail size={13} /> {label && <span>{label}</span>}
      </a>
    );
  }
  return (
    <Link data-testid={testId} to="/commissions" className={cls} aria-label={t("contact.buttonLabel")}>
      <Mail size={13} /> {label && <span>{label}</span>}
    </Link>
  );
}
